<template>
  <div>
    <form @submit="handleSubmit($event)">
      <div class="input-group">
        <input
          required
          v-model="phoneNumber"
          name="phoneNumber"
          type="text"
          class="form-control p-4"
          id="PhoneNumber"
          placeholder="Numer telefonu"
          minlength="1"
        />
        <span class="input-group-btn">
          <button type="submit" class="btn btn-outline-dark mr-3">
            Szukaj
          </button>
        </span>
      </div>
    </form>

    <div v-if="Object.keys(userByPhone).length !== 0">
      <div v-if="userByPhone.message">
        <p>{{ userByPhone.message }}</p>
      </div>
      <div v-else>
        <table class="table borderless  ">
          <thead>
            <tr class="tr-table">
              <th scope="col">ID użytkownika</th>
              <th scope="col">Utworzono</th>
              <th scope="col">Imię</th>
              <th scope="col">Nazwisko</th>
              <th scope="col">Data urodzenia</th>
              <th scope="col">id karty</th>
              <th scope="col">Pesel</th>
              <th scope="col">Ulica</th>
              <th scope="col">Nr domu</th>
              <th scope="col">Nr lokalu</th>
              <th scope="col">Kod pocztowy</th>
              <th scope="col">Miasto</th>
              <th scope="col">Numer konta</th>
              <th scope="col">Status</th>
              <th scope="col">Dystans</th>
              <th scope="col">Zdjęcie</th>
              <th scope="col">Status pracownika</th>
              <th scope="col">Usługi</th>
              <th scope="col">Wiadomość</th>
              <th scope="col">Szczegóły</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ userByPhone.user_profile.profile.id }}</td>
              <td>{{ userByPhone.user_profile.profile.creation_date }}</td>

              <td>{{ userByPhone.user_profile.profile.first_name }}</td>
              <td>{{ userByPhone.user_profile.profile.last_name }}</td>
              <td>
                {{
                  formattedDateWithoutTime(
                    userByPhone.user_profile.profile.birthdate
                  )
                }}
              </td>
              <td>{{ userByPhone.user_profile.profile.id_card }}</td>
              <td>{{ userByPhone.user_profile.profile.pesel }}</td>
              <td>{{ userByPhone.user_profile.profile.street }}</td>
              <td>{{ userByPhone.user_profile.profile.number1 }}</td>
              <td>{{ userByPhone.user_profile.profile.number2 }}</td>
              <td>{{ userByPhone.user_profile.profile.postcode }}</td>
              <td>{{ userByPhone.user_profile.profile.city }}</td>
              <td>{{ userByPhone.user_profile.profile.account_number }}</td>
              <td>{{ userByPhone.user_profile.profile.profile_status }}</td>
              <td>{{ userByPhone.user_profile.profile.distance }}</td>
              <td>{{ userByPhone.user_profile.profile.fileId }}</td>
              <td>{{ userByPhone.user_profile.profile.employee_status }}</td>

              <td>
                <button
                  type="button"
                  class="btn btn-outline-dark"
                  data-toggle="modal"
                  data-target="#exampleModal"
                >
                  Usługi
                </button>
              </td>
              <td>
                <router-link
                  :to="{ path: '../chat/' + userByPhone.user_profile.user.id }"
                >
                  <button type="button" class="btn btn-outline-dark mr-3">
                    Napisz
                  </button>
                </router-link>
              </td>
              <td>
                <router-link
                  :to="{
                    path: '../users/id/' + userByPhone.user_profile.user.id,
                  }"
                >
                  <button type="button" class="btn btn-outline-dark mr-3" @click="getUser(userByPhone.user_profile.user.id)">
                    Przejdź
                  </button>
                </router-link>
              </td>
              <div
                class="modal fade"
                id="exampleModal"
                tabindex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div class="modal-dialog modal-xl modal-lg" role="document">
                  <div class="modal-content services-modal">
                    <div class="modal-header">
                      <h5 class="modal-title" id="exampleModalLabel">
                        Usługi użytkownika
                      </h5>
                      <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body">
                      <table class="table modal-table">
                        <thead>
                          <tr class="tr-table">
                            <th scope="col">ID</th>
                            <th scope="col">Cena</th>

                            <th scope="col">ID usługi</th>
                            <th scope="col">Nazwa</th>
                            <th scope="col">Pierwszy próg</th>
                            <th scope="col">Drugi próg</th>
                            <th scope="col">Typ</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="item in userByPhone.user_services"
                            v-bind:key="item.id"
                          >
                            <td>{{ item.id }}</td>
                            <td>{{ item.price }}</td>

                            <td>{{ item.service.id }}</td>
                            <td>{{ item.service.display_name }}</td>
                            <td>{{ item.service.first_threshold }}</td>
                            <td>{{ item.service.second_threshold }}</td>
                            <td>{{ item.service.type }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-outline-dark"
                        data-dismiss="modal"
                      >
                        Zamknij
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import shared from "../shared";
export default {
  name: "SearchUser",
  computed: {
    userByPhone() {
      return this.$store.getters.getUserByPhone.userByPhone;
    },
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      this.$store.dispatch("getUserByPhone", {
        phone: this.phoneNumber,
      });
    },
  },
  data() {
    return {
      phoneNumber: "",
    };
  },
  created() {
    this.formattedDateWithoutTime = shared.formattedDateWithoutTime;
  },
};
</script>

<style scoped>
.input-group {
  align-items: center;
  margin: 20px;
  padding: 20px;
}
.form-control {
  margin: 0 10px;
}
.services-modal {
  width: 900px;
  top: 0px;
  left: 50%;
  transform: translate(-50%, 0%);
}
</style>
